/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import {
  SidebarWrapper,
  SidebarBtnContainer,
  SideBarList,
  SideBarOption,
  LogoContainer,
} from './Sidebar.styled'
import { ILink, linksAdmin, linksClient } from '../../constants/links'
import { useNavigate } from 'react-router-dom'
import Chevron from '../../assets/icons/Chevron'
import useAuth from '../../hooks/useAuth'
import { v4 } from 'uuid'
import { useSelector, useDispatch } from 'react-redux'
import { toggleSideBar } from 'features/global/globalSlice'
import { RootState } from 'store'
import { AimAIcon } from 'assets/icons/AimA'
import { AimIIcon } from 'assets/icons/AimI'
import { AimMIcon } from 'assets/icons/AimM'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Flex } from 'styling/GlobalStyles'

const Sidebar = React.memo(function Sidebar() {
  const { isSidebarOpen } = useSelector((store: RootState) => store.globals)
  const { user } = useSelector((state: RootState) => state.user)
  const { isAdmin } = useAuth()
  const [links, setLinks] = useState<ILink[]>([])
  const navigate = useNavigate()
  const pathname = `/${location.pathname.split('/')[1]}`
  const dispatch = useDispatch()


  const getGroup = async () => {
    const groups = await fetchAuthSession().then(
      session => session.tokens?.idToken?.payload['cognito:groups']
    );
    return groups
  }

  useEffect(() => {

    const getLinks = async () => {
      const groups = await fetchAuthSession().then(
        session => session.tokens?.idToken?.payload['cognito:groups']
      )
      if (isAdmin) {
        setLinks(linksAdmin)
      } else {
        if ((groups as string[])?.includes('company_administrator')) {
          setLinks(linksClient)
        } else {
          setLinks(linksClient.filter(l => l.abr == 'ops' || user?.currentContract?.role?.permissionPolicy[l.abr])) //TODO Naci nacin kako da se univerzalno pisu rute koje svi vide

        }
      }
    }

    getLinks()

  }, [isAdmin])

  const getFirstPath = (str: string) => {
    return str.split('/').filter(Boolean)[0] || "";
  };

  return (
    <>
      {/* @ts-ignore */}
      <SidebarWrapper sidebar={isSidebarOpen} onMouseLeave={() => dispatch(toggleSideBar(false))} onMouseEnter={() => dispatch(toggleSideBar(true))} >
        <LogoContainer>
          <AimAIcon />
          {isSidebarOpen && <AimIIcon />}
          {isSidebarOpen && <AimMIcon />}
        </LogoContainer>
        <SidebarBtnContainer>
          {links.length == 1 ? links[0].list ? links[0].list.map(i => {
            return <SideBarOption onClick={() => {
              navigate(`${i.path}`)
            }}
              active={
                location.pathname.includes(i.path)
              } open={isSidebarOpen} >
              <div className='icon-container' >{i.icon}</div>
              <p>{i.name}</p>
            </SideBarOption>
          }) : <SideBarOption onClick={() => {
            navigate(`${links[0].path}`)
          }}
            active={
              (pathname == '/' && links[0].text == 'employees') ||
              pathname === links[0].path ||
              pathname.includes(links[0].path.split('-')[0])
            } open={isSidebarOpen} >
            <div className='icon-container' >{links[0].icon}</div>
            <p>{links[0].text}</p>
            {links[0].list && <Chevron
              gray={pathname === links[0].path || pathname.includes(links[0].path.split('-')[0])}
              open={
                pathname === links[0].path || pathname.includes(links[0].path.split('-')[0])
              }
            />}
          </SideBarOption> : links.map((item) => {
            const { text, icon, list } = item

            return (
              <>
                <SideBarOption onClick={() => {
                  navigate(`${item.path}`)
                }}
                  active={
                    getFirstPath(item.path).includes(getFirstPath(pathname) ?? '11') ||
                    (pathname == '/' && text == 'employees') ||
                    pathname === item.path ||
                    pathname.includes(item.path.split('-')[0])
                  } open={isSidebarOpen} >
                  <div className='icon-container' >{icon}</div>
                  <p>{text}</p>
                  {list && <Chevron
                    gray={pathname === item.path || pathname.includes(item.path.split('-')[0])}
                    open={
                      pathname === item.path || pathname.includes(item.path.split('-')[0])
                    }
                  />}
                </SideBarOption>
                {isSidebarOpen && list && (list.some(l => location.pathname.includes(l.path)) || pathname === item.path || pathname.includes(item.path.split('-')[0])) && (
                  <SideBarList >
                    {list.map((i) => {
                      return (
                        <SideBarOption
                          onClick={() => navigate(i.path)}
                          active={location.pathname.includes(i.path)}
                          key={i.name}
                          open={isSidebarOpen}
                          subOption={true}
                        >
                          <Flex gap='1rem' center >
                            <p>{i.name}</p>
                          </Flex>
                        </SideBarOption>
                      )
                    })}
                  </SideBarList>
                )}
              </>
            )
          })}
        </SidebarBtnContainer>
      </SidebarWrapper>
    </>
  )
})

export default Sidebar
